class a {
  static NUMBER = "number";
  static STRING = "string";
  static BOOLEAN = "boolean";
  static ARRAY = "array";
  name;
  modelName;
  defaultValue;
  alwaysWriteJson;
  type;
  required;
  fixed;
  constructor(t, e, s, i) {
    this.name = t, this.modelName = e, this.defaultValue = s, this.alwaysWriteJson = i, this.required = !1, this.fixed = !1, this.type = "any";
  }
  setType(t) {
    return this.type = t, this;
  }
  setRequired() {
    return this.required = !0, this;
  }
  setFixed() {
    return this.fixed = !0, this;
  }
}
export {
  a as Attribute
};
//# sourceMappingURL=Attribute.js.map
